(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/engine/assets/javascripts/definitions/fulltraff.js') >= 0) return;  svs.modules.push('/components/tipsen/engine/assets/javascripts/definitions/fulltraff.js'); "use strict";

let isSelfService;
let EventTypeId;
let productIds;
let xpertSizes;
let constants;
let brandMapping;
if (svs.isServer) {
  const trinidad = require('trinidad-core').core;
  constants = require('../constants.es6');
  isSelfService = trinidad.config.options.isSelfService;
  productIds = trinidad.components.require('utils', 'products').productIds;
  EventTypeId = require('../../../../../sportinfo/common/assets/javascripts/constants.es6').EventTypeId;
  xpertSizes = require('../xpertSystems/8-13-signs.es6').xpertSizes;
  brandMapping = require('../../../../../lb-utils/brand-mapping/assets/javascripts/brand-mapping.es6');
} else {
  var _svs$core$config$data;
  isSelfService = (_svs$core$config$data = svs.core.config.data.svsconfig) === null || _svs$core$config$data === void 0 ? void 0 : _svs$core$config$data.isSelfService;
  EventTypeId = svs.components.sportinfo.common.constants.EventTypeId;
  productIds = svs.utils.products.productIds;
  xpertSizes = svs.components.tipsen.engine.xpertSystems.signs8rows13.xpertSizes;
  constants = svs.components.tipsen.engine.constants;
  brandMapping = svs.components.lbUtils.brandMapping.fn;
}
const fulltraffDefinition = {
  outcomes: {
    eventTypeId: EventTypeId.GOAL_COUNT
  },
  competitions: [],
  rSystems: [],
  uSystems: [],
  systems: [constants.systems.SYSTEM_MSYS],
  betAmounts: [1],
  weeks: [1, 5, 10],
  sportkryssFactors: [0],
  sportkryssBase: 10,
  addonPixSize: [0],
  maxSystemSize: 30000,
  drawProductIds: [productIds.FULLTRAFF],
  xpertMsys: xpertSizes,
  xpertMsysSpecialValues: [48, 96, 128, 144, 192, 256, 384, 512, 972, 1024],
  quickPlayPixSizes: [48, 96, 128, 144, 192, 256, 384, 512],
  displayName: brandMapping.getProductDisplayName(productIds.FULLTRAFF),
  brandName: brandMapping.getSiteBrand(productIds.FULLTRAFF),
  brandLogo: brandMapping.getProductBrand(productIds.FULLTRAFF),
  competitionId: brandMapping.getProductCompetitionId(productIds.FULLTRAFF),
  getDisplayNameByDraw: draw => brandMapping.getProductDisplayNameByDraw(draw, productIds.FULLTRAFF),
  getBrandNameByDraw: draw => brandMapping.getSiteBrandByDraw(draw, productIds.FULLTRAFF),
  getBrandNamesByDraw: draw => brandMapping.getProductBrandsByDraw(draw, productIds.FULLTRAFF),
  getBrandLogoByDraw: draw => brandMapping.getProductBrandByDraw(draw, productIds.FULLTRAFF),
  getBrandMenuColorByDraw: draw => brandMapping.getProductBrandMenuColorByDraw(draw, productIds.FULLTRAFF),
  maxExternalSystemSize: 30000,
  features: {
    marketplace: true,
    singles: false
  },
  getRelatedProduct: () => null,
  getTransfer: () => null,
  pixSystems: [],
  minGroupAmount: 10,
  minStake: 1,
  hasGuaranteedJackpot: true,
  hasJackpot: true,
  tipsinfoSupport: [constants.tipsinfo.Odds, constants.tipsinfo.StartOdds, constants.tipsinfo.SvenskaFolket, constants.tipsinfo.Matchstart, constants.tipsinfo.Favourites, constants.tipsinfo.Analys],
  tipsinfoSupportResult: [constants.tipsinfo.Odds, constants.tipsinfo.SvenskaFolket, constants.tipsinfo.Favourites],
  loadDrawsApiPath: 'fulltraff',
  moduleEngine: 'fulltraff',
  defaultCouponValues: {
    betAmountIndex: 0,
    pixSize: 96,
    reduceModeCount: 20
  },
  pixSystem: constants.PixSystem.SportPix,
  externalChunkSize: {
    SROW: 1000,
    MSYS: 550,
    SROW_MARKETPLACE_GROUP: 950,
    MSYS_MARKETPLACE_GROUP: 515
  },
  couponSettings: []
};
if (!isSelfService) {
  fulltraffDefinition.systems.push(constants.systems.SYSTEM_REDUCERA_FRITT);
}
if (svs.isServer) {
  module.exports = fulltraffDefinition;
} else {
  setGlobal('svs.components.tipsen.engine.definitions.fulltraff', fulltraffDefinition);
}
 })(window);